/**
 * English translations for the heartbeat component.
 *
 * These are the default English translations that provide
 * fallback support and serve as the reference implementation.
 */
const translations = {
	'security.heartbeat.banner.session-expires-prefix': 'Your session expires in',
	'security.heartbeat.banner.session-expired': 'Your session has expired',
	'security.heartbeat.banner.less-than-one-minute': 'less than 1 minute',
	'security.heartbeat.banner.minute': 'minute',
	'security.heartbeat.banner.minutes': 'minutes',
	'security.heartbeat.banner.hour': 'hour',
	'security.heartbeat.banner.hours': 'hours',
	'security.heartbeat.banner.and': 'and',
	'security.heartbeat.banner.keep-me-signed-in.label': 'Keep me signed in',
	'security.heartbeat.banner.remind-me-later.label': 'Remind me later',
	'security.heartbeat.banner.warning-icon.label': 'Warning',
	'security.heartbeat.banner.login-again.link': 'Log in again to continue',
};

export default translations;
